import { Suspense } from 'react';
import { Grid } from 'mui/core';

const PublicRoute = ({ route, ...rest }) => {
  const {
    additional: { component: Component },
  } = rest;

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '100%' }}
    >
      <Suspense fallback={null}>
        <Component {...route} />
      </Suspense>
    </Grid>
  );
};

PublicRoute.propTypes = {};

export default PublicRoute;
